import { useEffect } from "react";

/**
 * Global listener for beforeinstallprompt.
 * Stores the event on window.deferredPrompt so any component can trigger it.
 * Renders nothing — mount once at the app root.
 */
export default function PwaInstallPrompt() {
  useEffect(() => {
    // Already running in standalone mode — nothing to do
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone
    ) {
      window.__pwaInstalled = true;
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
      // Dispatch a custom event so InstallAppButton components can react
      window.dispatchEvent(new Event("pwa-prompt-ready"));
    };

    const installedHandler = () => {
      window.__pwaInstalled = true;
      window.deferredPrompt = null;
      window.dispatchEvent(new Event("pwa-installed"));
    };

    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", installedHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  return null;
}
